__turbopack_context__.v({
  "className": "sofia_sans_1ccb4847-module__EkeW5a__className",
});
